/**
 * ハンバーガーメニューのテキスト設定
 * 
 * メニューハンドルに基づいて、各メニュー項目に英字ラベルと説明文を追加します。
 * 
 * 使用方法:
 * 1. このファイルの menuTexts オブジェクトに、メニューハンドルをキーとしてテキストを追加
 * 2. メニューハンドルは、Shopify管理画面のナビゲーションで確認できます
 *    （例: メニュー項目のURLが /collections/products の場合、ハンドルは "products"）
 */

(function() {
  'use strict';

  // メニューハンドルとテキストのマッピング
  // カスタマイズ画面の設定から読み込む
  let menuTexts = {};
  
  // カスタマイズ画面の設定を読み込む（window.menuTextsConfigから）
  if (typeof window.menuTextsConfig !== 'undefined') {
    menuTexts = window.menuTextsConfig;
  }
  
  // フォールバック: 手動設定（カスタマイズ画面を使わない場合）
  // 以下のコメントを外して、手動で設定することもできます
  /*
  const manualMenuTexts = {
    'products': {
      label: 'PRODUCTS',
      description: '商品一覧をご覧いただけます'
    }
  };
  menuTexts = Object.assign({}, menuTexts, manualMenuTexts);
  */

  /**
   * メニューテキストを設定する関数
   */
  function setMenuTexts() {
    const menuItems = document.querySelectorAll('.menu-drawer__menu-item[data-menu-handle]');
    
    // デバッグモード: コンソールにメニューハンドル名を表示（開発時のみ）
    // 本番環境では false に設定してください
    const DEBUG_MODE = true;
    
    if (DEBUG_MODE && menuItems.length > 0) {
      console.log('=== メニューハンドル一覧 ===');
      menuItems.forEach(function(menuItem) {
        const handle = menuItem.getAttribute('data-menu-handle');
        const title = menuItem.querySelector('.menu-item-title')?.textContent || 'タイトルなし';
        console.log('ハンドル: "' + handle + '" | タイトル: ' + title);
      });
      console.log('========================');
    }
    
    menuItems.forEach(function(menuItem) {
      const handle = menuItem.getAttribute('data-menu-handle');
      const textConfig = menuTexts[handle];
      
      if (textConfig) {
        const labelElement = menuItem.querySelector('.menu-item-label');
        const descriptionElement = menuItem.querySelector('.menu-item-description');
        
        // 英字ラベルを設定
        if (labelElement) {
          if (textConfig.label && textConfig.label.trim() !== '') {
            labelElement.textContent = textConfig.label;
            labelElement.style.display = 'block';
          } else {
            labelElement.style.display = 'none';
          }
        }
        
        // 説明文を設定
        if (descriptionElement) {
          if (textConfig.description && textConfig.description.trim() !== '') {
            descriptionElement.textContent = textConfig.description;
            descriptionElement.style.display = 'block';
          } else {
            descriptionElement.style.display = 'none';
          }
        }
      } else {
        // テキスト設定がない場合は非表示
        const labelElement = menuItem.querySelector('.menu-item-label');
        const descriptionElement = menuItem.querySelector('.menu-item-description');
        if (labelElement) labelElement.style.display = 'none';
        if (descriptionElement) descriptionElement.style.display = 'none';
      }
    });
  }

  // DOMContentLoaded時に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setMenuTexts);
  } else {
    setMenuTexts();
  }

  // メニュードロワーが開かれたときにも実行（動的に追加される要素に対応）
  document.addEventListener('click', function(event) {
    const menuDrawer = event.target.closest('header-drawer');
    if (menuDrawer) {
      setTimeout(setMenuTexts, 100);
    }
  });
})();

